import * as config from '../wips.config.js';
import { getTabRechte } from '../helpers/getTabRechte';
import { i18n } from '../i18n/i18n';
import { IDs } from '../helpers/IDs';
import { RoutingIDs } from '../helpers/RoutingAdminIDs';
import { StructureService } from '../services/structure_service';

export class Navigation {

    private dataGlobal: any = {};
    private devFeatures: boolean = config.devFeatures || false;
    private devFeaturesMap: any = config.devFeaturesMap || {};
    private noTranslation: boolean;
    private rechte: any = null;

    constructor(data: any, noTranslation?: boolean) {
        this.dataGlobal = data || {};
        this.noTranslation = !!noTranslation;
    }

    public getData(callback: (data: any) => void): void {
        this.processRechte(() => {
            if (typeof callback === 'function') {
                callback(this.buildArray())
            }
        });
    }

    protected buildArray(): any[] {
        const rechte: any = this.rechte || {};
        const bereichsstruktur: any = rechte.bereichsstruktur || {};
        const datenverwaltung: any = rechte.datenverwaltung || {};
        const energie: any = rechte.energie || {};
        const inhalte: any = rechte.inhalte || {};
        const kennzahlen_datenbank: any = rechte.kennzahlen_datenbank || {};
        const kommunikation: any = rechte.kommunikation || {};
        const pv_tool: any = rechte.pv_tool || {};
        const tab: any = rechte.tab || {};
        const unternehmensdatenbank: any = rechte.unternehmensdatenbank || {};

        return [
            {
                name: this.i18n('START', 'tab'),
                color: this.getColor(tab.startseite),
                path: RoutingIDs.ROUTE_START,
                disabled: !tab.startseite.visible
            },
            {
                name: this.i18n('Rechteverwaltung', 'tab'),
                color: this.getColor(tab.rechteverwaltung),
                path: RoutingIDs.ROUTE_RECHTEVERWALTUNG,
                disabled: !tab.rechteverwaltung.visible,
                children: [
                    {
                        name: this.i18n('Benutzer', 'tab'),
                        color: this.getColor(tab.rechteverwaltung),
                        path: RoutingIDs.ROUTE_RECHTEVERWALTUNG_BENUTZER,
                        disabled: !tab.rechteverwaltung.visible
                    },
                    {
                        name: this.i18n('Rechte', 'tab'),
                        color: this.getColor(tab.rechteverwaltung),
                        path: RoutingIDs.ROUTE_RECHTEVERWALTUNG_RECHTE,
                        disabled: !tab.rechteverwaltung.visible
                    },
                    {
                        name: this.i18n('Gruppen', 'tab'),
                        color: this.getColor(tab.rechteverwaltung),
                        path: RoutingIDs.ROUTE_RECHTEVERWALTUNG_GRUPPEN,
                        disabled: !tab.rechteverwaltung.visible
                    }
                ]
            },
            {
                name: this.i18n('Datenverwaltung', 'tab'),
                color: this.getColor(tab.datenverwaltung),
                path: RoutingIDs.ROUTE_DATENVERWALTUNG,
                disabled: !tab.datenverwaltung.visible,
                children: [
                    {
                        name: this.i18n('Bereichsstruktur', 'tab'),
                        color: this.getColor(datenverwaltung.bereichsstruktur),
                        path: RoutingIDs.ROUTE_DATENVERWALTUNG_BEREICHSSTRUKTUR,
                        disabled: !datenverwaltung.bereichsstruktur.visible,
                        children: [
                            {
                                name: this.i18n('Bereiche', 'tab'),
                                color: this.getColor(bereichsstruktur.bereiche),
                                path: RoutingIDs.ROUTE_BEREICHSSTRUKTUR_BEREICHE,
                                disabled: !bereichsstruktur.bereiche.visible
                            },
                            {
                                name: this.i18n('Gewerke (Definition)', 'tab'),
                                color: this.getColor(bereichsstruktur.gewerke),
                                path: RoutingIDs.ROUTE_BEREICHSSTRUKTUR_GEWERKE_DEFINITION,
                                disabled: !bereichsstruktur.gewerke.visible
                            },
                            {
                                name: this.i18n('WZ (Definition)', 'tab'),
                                color: this.getColor(bereichsstruktur.wz),
                                path: RoutingIDs.ROUTE_BEREICHSSTRUKTUR_WZ_DEFINITION,
                                disabled: !bereichsstruktur.wz.visible
                            },
                            {
                                name: this.i18n('Gewerkegruppen', 'tab'),
                                color: this.getColor(bereichsstruktur.gewerkegruppen),
                                path: RoutingIDs.ROUTE_BEREICHSSTRUKTUR_GEWERKE_GRUPPE,
                                disabled: !bereichsstruktur.gewerkegruppen.visible
                            }
                        ]
                    },
                    {
                        name: this.i18n('Energie', 'tab'),
                        color: this.getColor(datenverwaltung.energie),
                        path: RoutingIDs.ROUTE_DATENVERWALTUNG_ENERGIE,
                        disabled: !datenverwaltung.energie.visible,
                        children: [
                            {
                                name: this.i18n('Energiesteuer', 'tab'),
                                color: this.getColor(energie.energiesteuer),
                                path: RoutingIDs.ROUTE_ENERGIE_ENERGIESTEUER,
                                disabled: !energie.energiesteuer.visible
                            },
                            {
                                name: this.i18n('Heizwerte', 'tab'),
                                color: this.getColor(energie.heizwerte),
                                path: RoutingIDs.ROUTE_ENERGIE_HEIZWERTE,
                                disabled: !energie.heizwerte.visible
                            },
                            {
                                name: this.i18n('Quellen', 'tab'),
                                color: this.getColor(energie.quellen),
                                path: RoutingIDs.ROUTE_ENERGIE_QUELLEN,
                                disabled: !energie.quellen.visible
                            },
                            {
                                name: this.i18n('Gradtagzahlen', 'tab'),
                                color: this.getColor(energie.gradtagszahlen),
                                path: RoutingIDs.ROUTE_ENERGIE_GRADTAGSZAHLEN,
                                disabled: !energie.gradtagszahlen.visible
                            },
                            {
                                name: this.i18n('Gradtagzahlen Orte', 'tab'),
                                color: this.getColor(energie.gradtagszahlen_orte),
                                path: RoutingIDs.ROUTE_ENERGIE_GRADTAGSZAHLEN_ORTE,
                                disabled: !energie.gradtagszahlen_orte.visible
                            }
                        ]
                    },
                    {
                        name: this.i18n('Inhalte / Support / Parameter', 'tab'),
                        color: this.getColor(datenverwaltung.inhalte),
                        path: RoutingIDs.ROUTE_DATENVERWALTUNG_INHALTE_SUPPORT_PARAMETER,
                        disabled: !datenverwaltung.inhalte.visible,
                        children: [
                            {
                                name: this.i18n('FAQ', 'tab'),
                                color: this.getColor(inhalte.faq),
                                path: RoutingIDs.ROUTE_INHALTE_SUPPORT_PARAMETER_FAQ,
                                disabled: !inhalte.faq.visible || !this.devFeaturesMap.N214_FAQ
                            },
                            {
                                name: this.i18n('Glossar', 'tab'),
                                color: this.getColor(inhalte.glossar),
                                path: RoutingIDs.ROUTE_INHALTE_SUPPORT_PARAMETER_GLOSSAR,
                                disabled: !inhalte.glossar.visible
                            },
                            {
                                name: this.i18n('Glossar-Zuordnung', 'tab'),
                                color: this.getColor(inhalte.glossar_zuordnung),
                                path: RoutingIDs.ROUTE_INHALTE_SUPPORT_PARAMETER_GLOSSAR_ZUORDNUNG,
                                disabled: !inhalte.glossar_zuordnung.visible
                            },
                            {
                                name: this.i18n('Systemtexte', 'tab'),
                                color: this.getColor(inhalte.systemtexte),
                                path: RoutingIDs.ROUTE_INHALTE_SUPPORT_PARAMETER_SYSTEMTEXTE,
                                disabled: !inhalte.systemtexte.visible
                            },
                            {
                                name: this.i18n('Systemtexte-Zuordnung', 'tab'),
                                color: this.getColor(inhalte.systemtexte_zuordnung),
                                path: RoutingIDs.ROUTE_INHALTE_SUPPORT_PARAMETER_SYSTEMTEXTE_ZUORDNUNG,
                                disabled: !inhalte.systemtexte_zuordnung.visible
                            },
                            {
                                name: this.i18n('Online-Hilfe', 'tab'),
                                color: this.getColor(inhalte.online_hilfe),
                                path: RoutingIDs.ROUTE_INHALTE_SUPPORT_PARAMETER_ONLINE_HILFE,
                                disabled: !inhalte.online_hilfe.visible
                            },
                            {
                                name: this.i18n('Bundesländer', 'tab'),
                                color: this.getColor(inhalte.bundeslaender),
                                path: RoutingIDs.ROUTE_INHALTE_SUPPORT_PARAMETER_BUNDESLAENDER,
                                disabled: !inhalte.bundeslaender.visible
                            },
                            {
                                name: this.i18n('Zertifizierungsoptionen', 'tab'),
                                color: this.getColor(inhalte.zertifizierungsoptionen),
                                path: RoutingIDs.ROUTE_INHALTE_SUPPORT_PARAMETER_ZERTIFIZIERUNGSOPTIONEN,
                                disabled: !inhalte.zertifizierungsoptionen.visible
                            },
                            {
                                name: this.i18n('Zertifizierung-Zuordnung', 'tab'),
                                color: this.getColor(inhalte.zertifizierung_zuordnung),
                                path: RoutingIDs.ROUTE_INHALTE_SUPPORT_PARAMETER_ZERTIFIZIERUNG_ZUORDNUNG,
                                disabled: !inhalte.zertifizierung_zuordnung.visible
                            },
                            {
                                name: this.i18n('Förderung', 'tab'),
                                color: this.getColor(inhalte.foerderung),
                                path: RoutingIDs.ROUTE_INHALTE_SUPPORT_PARAMETER_FOERDERUNG,
                                disabled: !inhalte.foerderung.visible
                            },
                            {
                                name: this.i18n('Förderung-Zuordnung', 'tab'),
                                color: this.getColor(inhalte.foerderung_zuordnung),
                                path: RoutingIDs.ROUTE_INHALTE_SUPPORT_PARAMETER_FOERDERUNG_ZUORDNUNG,
                                disabled: !inhalte.foerderung_zuordnung.visible
                            },
                            {
                                name: this.i18n('Partner:innen', 'tab'),
                                color: this.getColor(inhalte.partner),
                                path: RoutingIDs.ROUTE_INHALTE_SUPPORT_PARAMETER_PARTNER,
                                disabled: !inhalte.partner.visible
                            },
                            {
                                name: this.i18n('Partner:innen-Zuordnung', 'tab'),
                                color: this.getColor(inhalte.partner_zuordnung),
                                path: RoutingIDs.ROUTE_INHALTE_SUPPORT_PARAMETER_PARTNER_ZUORDNUNG,
                                disabled: !inhalte.partner_zuordnung.visible
                            },
                            {
                                name: this.i18n('Systemparameter', 'tab'),
                                color: this.getColor(inhalte.systemparameter),
                                path: RoutingIDs.ROUTE_INHALTE_SUPPORT_PARAMETER_SYSTEMPARAMETER,
                                disabled: !inhalte.systemparameter.visible
                            },
                            {
                                name: this.i18n('Dateien', 'tab'),
                                color: this.getColor(inhalte.systemparameter),
                                path: RoutingIDs.ROUTE_INHALTE_SUPPORT_PARAMETER_DATEIEN,
                                disabled: !inhalte.systemparameter.visible
                            },
                            {
                                name: this.i18n('Medien', 'tab'),
                                color: this.getColor(inhalte.systemparameter),
                                path: RoutingIDs.ROUTE_INHALTE_SUPPORT_PARAMETER_MEDIEN,
                                disabled: !inhalte.systemparameter.visible
                            },
                            {
                                name: this.i18n('Plausibilisierung', 'tab'),
                                color: this.getColor(inhalte.plausibilisierung),
                                path: RoutingIDs.ROUTE_INHALTE_SUPPORT_PARAMETER_PLAUSIBILISIERUNG,
                                disabled: !inhalte.plausibilisierung.visible
                            }
                        ]
                    },
                    {
                        name: this.i18n('CO₂-Fußabdruck', 'tab'),
                        color: this.getColor(datenverwaltung.co2),
                        path: RoutingIDs.ROUTE_DATENVERWALTUNG_CO2_FUSSABDRUCK,
                        disabled: !datenverwaltung.co2.visible,
                        children: [
                            {
                                name: this.i18n('Faktoren Klimagase (S1)', 'tab'),
                                color: this.getColor(datenverwaltung.co2),
                                path: RoutingIDs.ROUTE_CO2_FUSSABDRUCK_FAKTOREN_KLIMAGASE,
                                disabled: !datenverwaltung.co2.visible
                            },
                            {
                                name: this.i18n('Faktoren Brennstoffe (S1 / S2 / S3)', 'tab'),
                                color: this.getColor(datenverwaltung.co2),
                                path: RoutingIDs.ROUTE_CO2_FUSSABDRUCK_FAKTOREN_BRENNSTOFFE,
                                disabled: !datenverwaltung.co2.visible
                            },
                            {
                                name: this.i18n('1. Materialien / Produkte (S3)', 'tab'),
                                color: this.getColor(datenverwaltung.co2),
                                path: RoutingIDs.ROUTE_CO2_FUSSABDRUCK_MATERIALIEN,
                                disabled: !datenverwaltung.co2.visible
                            },
                            {
                                name: this.i18n('2. Güter (S3)', 'tab'),
                                color: this.getColor(datenverwaltung.co2),
                                path: RoutingIDs.ROUTE_CO2_FUSSABDRUCK_GUETER,
                                disabled: !datenverwaltung.co2.visible
                            },
                            {
                                name: this.i18n('4./9. Transporte (S3)', 'tab'),
                                color: this.getColor(datenverwaltung.co2),
                                path: RoutingIDs.ROUTE_CO2_FUSSABDRUCK_TRANSPORTE,
                                disabled: !datenverwaltung.co2.visible
                            },
                            {
                                name: this.i18n('5. Abfälle (S3)', 'tab'),
                                color: this.getColor(datenverwaltung.co2),
                                path: RoutingIDs.ROUTE_CO2_FUSSABDRUCK_ABFAELLE,
                                disabled: !datenverwaltung.co2.visible
                            },
                            {
                                name: this.i18n('6. Reisen/Entfernung (S3)', 'tab'),
                                color: this.getColor(datenverwaltung.co2),
                                path: RoutingIDs.ROUTE_CO2_FUSSABDRUCK_REISEN_ENTFERNUNG,
                                disabled: !datenverwaltung.co2.visible
                            },
                            {
                                name: this.i18n('6. Reisen/Übernachtung (S3)', 'tab'),
                                color: this.getColor(datenverwaltung.co2),
                                path: RoutingIDs.ROUTE_CO2_FUSSABDRUCK_REISEN_UEBERNACHTUNG,
                                disabled: !datenverwaltung.co2.visible
                            },
                            {
                                name: this.i18n('7. Pendeln (S3)', 'tab'),
                                color: this.getColor(datenverwaltung.co2),
                                path: RoutingIDs.ROUTE_CO2_FUSSABDRUCK_PENDELN,
                                disabled: !datenverwaltung.co2.visible
                            },
                            {
                                name: this.i18n('6./9. Unterkunft (S3)', 'tab'),
                                color: this.getColor(datenverwaltung.co2),
                                path: RoutingIDs.ROUTE_CO2_FUSSABDRUCK_UNTERKUNFT,
                                disabled: !datenverwaltung.co2.visible
                            },
                            {
                                name: this.i18n('Angemietete Räumlichkeiten', 'tab'),
                                color: this.getColor(datenverwaltung.co2),
                                path: RoutingIDs.ROUTE_CO2_FUSSABDRUCK_ANGEMIETETE_RAEUMLICHKEITEN,
                                disabled: !datenverwaltung.co2.visible
                            },
                            {
                                name: this.i18n('Angemietete Fahrzeuge', 'tab'),
                                color: this.getColor(datenverwaltung.co2),
                                path: RoutingIDs.ROUTE_CO2_FUSSABDRUCK_ANGEMIETETE_FAHRZEUGE,
                                disabled: !datenverwaltung.co2.visible
                            },
                            {
                                name: this.i18n('Template-Dateien', 'tab'),
                                color: this.getColor(datenverwaltung.co2),
                                path: RoutingIDs.ROUTE_CO2_FUSSABDRUCK_DATEIABLAGE,
                                disabled: !datenverwaltung.co2.visible
                            }
                        ]
                    },
                    {
                        name: this.i18n('Kataloge', 'tab'),
                        color: this.getColor(datenverwaltung.kataloge),
                        path: RoutingIDs.ROUTE_DATENVERWALTUNG_KATALOGE,
                        disabled: !datenverwaltung.kataloge.visible,
                        children: this.buildKatalogeArray()
                    }
                ]
            },
            {
                name: this.i18n('Kennzahlen-Datenbank', 'tab'),
                color: this.getColor(tab.kennzahlen_datenbank),
                path: RoutingIDs.ROUTE_KENNZAHLEN_DATENBANK,
                disabled: !tab.kennzahlen_datenbank.visible,
                children: [
                    {
                        name: this.i18n('Kennzahlen (Definition)', 'tab'),
                        color: this.getColor(kennzahlen_datenbank.kennzahlen),
                        path: RoutingIDs.ROUTE_KENNZAHLEN_DATENBANK_KENNZAHLEN_DEFINITION,
                        disabled: !kennzahlen_datenbank.kennzahlen.visible
                    },
                    {
                        name: this.i18n('Import (Initial)', 'tab'),
                        color: this.getColor(kennzahlen_datenbank['import.initial']),
                        path: RoutingIDs.ROUTE_KENNZAHLEN_DATENBANK_IMPORT_INITIAL,
                        disabled: !kennzahlen_datenbank['import.initial'].visible
                    },
                    {
                        name: this.i18n('Import (E-Tool)', 'tab'),
                        color: this.getColor(kennzahlen_datenbank['import.etool']),
                        path: RoutingIDs.ROUTE_KENNZAHLEN_DATENBANK_IMPORT_E_TOOL,
                        disabled: !kennzahlen_datenbank['import.etool'].visible
                    },
                    {
                        name: this.i18n('Daten - Roh', 'tab'),
                        color: this.getColor(kennzahlen_datenbank['daten.roh']),
                        path: RoutingIDs.ROUTE_KENNZAHLEN_DATENBANK_DATEN_ROH,
                        disabled: !kennzahlen_datenbank['daten.roh'].visible
                    },
                    {
                        name: this.i18n('Daten - Aggregiert', 'tab'),
                        color: this.getColor(kennzahlen_datenbank['daten.aggregiert']),
                        path: RoutingIDs.ROUTE_KENNZAHLEN_DATENBANK_DATEN_AGGREGIERT,
                        disabled: !kennzahlen_datenbank['daten.aggregiert'].visible
                    },
                    {
                        name: this.i18n('Datenbank - Export', 'tab'),
                        color: this.getColor(kennzahlen_datenbank['datenbank.export']),
                        path: RoutingIDs.ROUTE_KENNZAHLEN_DATENBANK_DATENBANK_EXPORT,
                        disabled: !kennzahlen_datenbank['datenbank.export'].visible
                    }
                ]
            },
            {
                name: this.i18n('Unternehmensdatenbank', 'tab'),
                color: this.getColor(tab.unternehmensdatenbank),
                path: RoutingIDs.ROUTE_UNTERNEHMENSDATENBANK,
                disabled: !tab.unternehmensdatenbank.visible,
                children: [
                    {
                        name: this.i18n('Kontakte', 'tab'),
                        color: this.getColor(unternehmensdatenbank.kontakte),
                        path: RoutingIDs.ROUTE_UNTERNEHMENSDATENBANK_KONTAKTE,
                        disabled: !unternehmensdatenbank.kontakte.visible
                    },
                    {
                        name: this.i18n('Unternehmen', 'tab'),
                        color: this.getColor(unternehmensdatenbank.unternehmen),
                        path: RoutingIDs.ROUTE_UNTERNEHMENSDATENBANK_UNTERNEHMEN,
                        disabled: !unternehmensdatenbank.unternehmen.visible
                    },
                    {
                        name: this.i18n('Registrierungen', 'tab'),
                        color: this.getColor(unternehmensdatenbank.registrierungen),
                        path: RoutingIDs.ROUTE_UNTERNEHMENSDATENBANK_REGISTRIERUNGEN,
                        disabled: !unternehmensdatenbank.registrierungen.visible
                    },
                    {
                        name: this.i18n('Berater', 'tab'),
                        color: this.getColor(unternehmensdatenbank.berater),
                        path: RoutingIDs.ROUTE_UNTERNEHMENSDATENBANK_BERATER,
                        disabled: !unternehmensdatenbank.berater.visible
                    },
                    {
                        name: this.i18n('Berater - Weitere Bereiche', 'tab'),
                        color: this.getColor(unternehmensdatenbank.berater),
                        path: RoutingIDs.ROUTE_UNTERNEHMENSDATENBANK_BERATER_WEITERE,
                        disabled: !unternehmensdatenbank.berater.visible
                    },
                    {
                        name: this.i18n('Beraterzuordnung', 'tab'),
                        color: this.getColor(unternehmensdatenbank.beraterzuordnung),
                        path: RoutingIDs.ROUTE_UNTERNEHMENSDATENBANK_BERATERZUORDNUNG,
                        disabled: !unternehmensdatenbank.beraterzuordnung.visible
                    },
                    {
                        name: this.i18n('HWK-Liste / Einrichtungen', 'tab'),
                        color: this.getColor(unternehmensdatenbank.hwk),
                        path: RoutingIDs.ROUTE_UNTERNEHMENSDATENBANK_HWK_LISTE,
                        disabled: !unternehmensdatenbank.hwk.visible
                    },
                    {
                        name: this.i18n('Verbände', 'tab'),
                        color: this.getColor(unternehmensdatenbank.verbaende),
                        path: RoutingIDs.ROUTE_UNTERNEHMENSDATENBANK_VERBAENDE,
                        disabled: !unternehmensdatenbank.verbaende.visible,
                        children: [
                            {
                                name: this.i18n('Verbandsliste', 'tab'),
                                color: this.getColor(unternehmensdatenbank.verbaende),
                                path: RoutingIDs.ROUTE_VERBAENDE_VERBANDSLISTE,
                                disabled: !unternehmensdatenbank.verbaende.visible
                            },
                            {
                                name: this.i18n('Verbandszuordnung', 'tab'),
                                color: this.getColor(unternehmensdatenbank.verbaende),
                                path: RoutingIDs.ROUTE_VERBAENDE_VERBANDSZUORDNUNG,
                                disabled: !unternehmensdatenbank.verbaende.visible
                            }
                        ]
                    },
                    {
                        name: this.i18n('Schulungsveranstaltungen', 'tab'),
                        color: this.getColor(unternehmensdatenbank.schulungsveranstaltungen),
                        path: RoutingIDs.ROUTE_UNTERNEHMENSDATENBANK_SCHULUNG,
                        disabled: !unternehmensdatenbank.schulungsveranstaltungen.visible
                    },
                    {
                        name: this.i18n('Mandanten-Benutzer', 'tab'),
                        color: this.getColor(unternehmensdatenbank.mandanten_user),
                        path: RoutingIDs.ROUTE_UNTERNEHMENSDATENBANK_MANDANTEN_BENUTZER,
                        disabled: !unternehmensdatenbank.mandanten_user.visible
                    },
                ]
            },
            {
                name: this.i18n('PV-Tool', 'tab'),
                color: this.getColor(pv_tool.pv_tool),
                path: RoutingIDs.ROUTE_PV_TOOL,
                disabled: !tab.pv_tool.visible,
                children: [
                    {
                        name: this.i18n('Erzeugungs- und Lastdaten', 'tab'),
                        color: this.getColor(pv_tool.daten),
                        path: RoutingIDs.ROUTE_PV_TOOL_ERZEUGUNGSDATEN_LASTDATEN,
                        disabled: !pv_tool.daten.visible,
                        children: [
                            {
                                name: this.i18n('Tabelle', 'tab'),
                                color: this.getColor(pv_tool.daten),
                                path: RoutingIDs.ROUTE_ERZEUGUNGSDATEN_LASTDATEN_TABELLE,
                                disabled: !pv_tool.daten.visible
                            },
                            {
                                name: this.i18n('Import', 'tab'),
                                color: this.getColor(pv_tool.daten),
                                path: RoutingIDs.ROUTE_ERZEUGUNGSDATEN_LASTDATEN_IMPORT,
                                disabled: !pv_tool.daten.visible
                            }
                        ]
                    },
                    {
                        name: this.i18n('EEG-Vergütung', 'tab'),
                        path: RoutingIDs.ROUTE_PV_TOOL_EEG_VERGUETUNG,
                        disabled: !pv_tool.eeg.visible
                    },
                    {
                        name: this.i18n('Parameter', 'tab'),
                        path: RoutingIDs.ROUTE_PV_TOOL_PARAMETER,
                        disabled: !pv_tool.parameter.visible
                    }
                ]
            },
            {
                name: this.i18n('Kommunikation', 'tab'),
                color: this.getColor(tab.kommunikation),
                path: RoutingIDs.ROUTE_KOMMUNIKATION,
                disabled: !tab.kommunikation.visible,
                children: [
                    {
                        name: this.i18n('Info-Mail', 'tab'),
                        color: this.getColor(kommunikation.info_mail),
                        path: RoutingIDs.ROUTE_KOMMUNIKATION_INFO_MAIL,
                        disabled: !kommunikation.info_mail.visible
                    },
                    {
                        name: this.i18n('Aktuelle Nachrichten', 'tab'),
                        color: this.getColor(kommunikation.aktuelle_nachrichten),
                        path: RoutingIDs.ROUTE_KOMMUNIKATION_AKTUELLE_NACHRICHTEN,
                        disabled: !kommunikation.aktuelle_nachrichten.visible
                    },
                    {
                        name: this.i18n('Aktuelle Termine', 'tab'),
                        color: this.getColor(kommunikation.aktuelle_nachrichten),
                        path: RoutingIDs.ROUTE_KOMMUNIKATION_AKTUELLE_TERMINE,
                        disabled: !kommunikation.aktuelle_nachrichten.visible
                    }
                ]
            },
            {
                name: this.i18n('Statistik', 'tab'),
                color: this.getColor(tab.statistik),
                path: RoutingIDs.ROUTE_STATISTIK,
                disabled: !tab.statistik.visible,
                children: [
                    {
                        name: this.i18n('Handwerk', 'tab'),
                        color: this.getColor(tab.statistik),
                        path: RoutingIDs.ROUTE_STATISTIK_HANDWERK,
                        disabled: !tab.statistik.visible
                    },
                    {
                        name: this.i18n('Kultur', 'tab'),
                        color: this.getColor(tab.statistik),
                        path: RoutingIDs.ROUTE_STATISTIK_KULTUR,
                        disabled: !tab.statistik.visible
                    },
                    {
                        name: this.i18n('Sonstige', 'tab'),
                        color: this.getColor(tab.statistik),
                        path: RoutingIDs.ROUTE_STATISTIK_SONSTIGE,
                        disabled: !tab.statistik.visible
                    }
                    // {
                    //     name: this.i18n('System', 'tab'),
                    //     color: this.getColor(tab.statistik),
                    //     path: RoutingIDs.ROUTE_STATISTIK_SYSTEM,
                    //     disabled: !tab.statistik.visible
                    // }
                ]
            }
        ];
    }

    protected buildKatalogeArray(): any[] {
        const data: any = [];
        const datenverwaltung: any = (this.rechte || {}).datenverwaltung || {};
        const structures: any = ((StructureService || {}).structures || {})[IDs.MOD_ETOOL_ADMIN] || {};
        let disabled: string[] = [];

        if (!this.devFeatures) {
            disabled = [IDs.ENT_KONTAKT_THEMEN];
        }

        Object.keys(structures).forEach((key: string) => {
            const basis_katalog: boolean = (structures[key].SRC || {}).basis_katalog || false;
            const entity: string = (structures[key].SRC || {}).id || null;
            const titel: string = this.i18n(structures[key].TITEL, 'tab') || null;

            if (!basis_katalog || !entity || !titel || disabled.indexOf(key) !== -1) {
                return;
            }
            data.push({ entity, titel });
        });

        return data
            .sort((a: any, b: any) => a.titel > b.titel ? 1 : (a.titel < b.titel ? -1 : 0))
            .map((katalog: any, index: number) => {
                const path: any = {
                    ...RoutingIDs.ROUTE_DATENVERWALTUNG_KATALOGE, hasSubs: false,
                    [RoutingIDs.TABS_DATENVERWALTUNG_KATALOGE]: index,
                    terminateOn: RoutingIDs.TABS_DATENVERWALTUNG_KATALOGE
                };
                return {
                    name: katalog.titel || null,
                    color: this.getColor(datenverwaltung.kataloge),
                    path,
                    disabled: !datenverwaltung.kataloge.visible
                };
            });
    }

    protected getColor(data: any): string {
        return ((data || {}).groups || {}).kultur ? 'black' : '#6692c3';
    }

    private i18n(value: string, key: string): string {
        return this.noTranslation ? value : i18n(value, key);
    }

    protected processRechte(callback: () => void): void {
        const rechte: any = {};
        const groups: any = {
            tab: {
                prefix: 'admin.tab',
                tabs: [
                    'startseite', 'rechteverwaltung', 'datenverwaltung', 'kennzahlen_datenbank', 'unternehmensdatenbank', 'pv_tool',
                    'kommunikation', 'statistik'
                ]
            },
            datenverwaltung: {
                prefix: 'admin.tab.datenverwaltung',
                tabs: ['bereichsstruktur', 'energie', 'inhalte', 'co2', 'kataloge']
            },
            kennzahlen_datenbank: {
                prefix: 'admin.tab.kennzahlen_datenbank',
                tabs: ['kennzahlen', 'import.initial', 'import.etool', 'daten.roh', 'daten.aggregiert', 'datenbank.export']
            },
            unternehmensdatenbank: {
                disabled: ['kontakte', 'unternehmen'],
                prefix: 'admin.tab.unternehmensdatenbank',
                tabs: ['kontakte', 'unternehmen', 'registrierungen', 'berater', 'beraterzuordnung', 'hwk', 'verbaende', 'schulungsveranstaltungen', 'mandanten_user']
            },
            bereichsstruktur: {
                prefix: 'admin.tab.datenverwaltung.bereichsstruktur',
                tabs: ['bereiche', 'gewerke', 'wz', 'gewerkegruppen']
            },
            energie: {
                prefix: 'admin.tab.datenverwaltung.energie',
                tabs: ['energiesteuer', 'heizwerte', 'quellen', 'gradtagszahlen', 'gradtagszahlen_orte']
            },
            inhalte: {
                prefix: 'admin.tab.datenverwaltung.inhalte',
                tabs: [
                    'faq', 'glossar', 'glossar_zuordnung', 'systemtexte', 'systemtexte_zuordnung', 'online_hilfe', 'bundeslaender',
                    'zertifizierungsoptionen', 'zertifizierung_zuordnung', 'foerderung', 'foerderung_zuordnung', 'partner',
                    'partner_zuordnung', 'systemparameter', 'plausibilisierung'
                ]
            },
            pv_tool: {
                prefix: 'admin.tab.pv_tool',
                tabs: ['daten', 'eeg', 'parameter']
            },
            kommunikation: {
                prefix: 'admin.tab.kommunikation',
                tabs: ['info_mail', 'aktuelle_nachrichten', 'aktuelle_nachrichten']
            }
        };
        const groupKeys: string[] = Object.keys(groups);

        groupKeys.forEach((key: string) => {
            const group: any = groups[key] || {};
            getTabRechte(
                { disabled: group.disabled || [], prefix: group.prefix || [], tabs: group.tabs || [] }, undefined,
                (data: any) => {
                    rechte[key] = data.rechte || {};

                    if (Object.keys(rechte).length === groupKeys.length) {
                        this.rechte = rechte;

                        if (typeof callback === 'function') {
                            callback();
                        }
                    }
                }
            );
        });
    }
}
